((app, ng) => {

    app.component("balances",
        {
            templateUrl: "/App/Dashboard/Tiles/Balances/balances.template.html",
            controller: balancesController,
            bindings: {
                currentUser: "<"
            }
        });

    function balancesController(externalMarketingDollarApi, $q, userApi) {
        const $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                loading: false
            }
        });

        $ctrl.$onInit = () => {
            $ctrl.marketingDollars = 0;
            $ctrl.totalAum = 0;
            $ctrl.totalIssuedPremium = 0;
            $ctrl.ui.loading = true;
            const promises = [
                userApi.getTotalIssuedPremium($ctrl.currentUser.Id),
                userApi.getTotalAum($ctrl.currentUser.Id),
                externalMarketingDollarApi.getUserMarketingDollars($ctrl.currentUser.Id)
            ];

            $q.all(promises)
                .then(responses => {
                    $ctrl.totalIssuedPremium = responses[0].TotalIssuedPremium;
                    $ctrl.totalAum = responses[1];
                    $ctrl.marketingDollars = responses[2].MarketingDollarsTotal;
                })
                .finally(() => $ctrl.ui.loading = false);
        };
    }

})(window.app, window.angular);